import { WISHLIST } from '../constants';

const updateWishlistButton = (wishlistButton, variantID) => {
  if (!wishlistButton || typeof window.ReloadSmartWishlist !== 'function') return null;

  const parent = wishlistButton.parentElement;
  const productID = wishlistButton.dataset.product;
  const buttonClasses = wishlistButton.className;
  const buttonId = wishlistButton.id;

  wishlistButton.remove();

  const newButton = document.createElement('button');
  newButton.className = buttonClasses;
  newButton.dataset.product = productID;
  newButton.dataset.variant = variantID;
  newButton.classList.remove(...WISHLIST.APP_ADDED_CLASSES);
  newButton.id = buttonId;

  parent.appendChild(newButton);
  window.ReloadSmartWishlist();

  return newButton;
};

export default updateWishlistButton;
